import React, { useEffect, useMemo, useState } from "react";
import "./index.css";
import { Alert, Badge, Col, Container, Dropdown, DropdownButton, Form, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import DommusBarraTitulo from "../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../components/DommusBarraTitulo/ItemBarraTitulo";
import { faEllipsisVertical, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import Swal from "sweetalert2"; import caAPI from "../../services/caAPI"; import { Icon } from "@iconify/react";
import calendarOutlineBadged from '@iconify-icons/clarity/calendar-outline-badged';
import DatePicker from "react-date-picker";
import moment from "moment";
import { CardEnviado } from "./CardEnviado";
import ReactTooltip from "react-tooltip";
import InfiniteScroll from "react-infinite-scroll-component";
import { DommusPlaceholderDetalhesAtendimento } from "../../components/DommusPlaceholderDetalhesAtendimento";
import EmailComponent from "../PortalCliente/DetalheAtendimento/EmailComponent";
import FiltroItensEnviados from "./FiltroItensEnviados";
import ModalDommus from "../../components/Modal";
import { errorToast, successToast } from "../../components/DommusToast";
import fileDownload from "js-file-download";

const componenteLoadingAtendimento = (
  <div className="loading-mensagens-skeleton">
    <div className="item-loading-atendimento-skeleton skeleton-animation"></div>
    <div className="item-loading-atendimento-skeleton skeleton-animation"></div>
    <div className="item-loading-atendimento-skeleton skeleton-animation"></div>
    <div className="item-loading-atendimento-skeleton skeleton-animation"></div>
    <div className="item-loading-atendimento-skeleton skeleton-animation"></div>
    <div className="item-loading-atendimento-skeleton skeleton-animation"></div>
    <div className="item-loading-atendimento-skeleton skeleton-animation"></div>
  </div>
)

const componenteLoadingMensagens = (
  <div className="loading-mensagens-skeleton">
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
    <div className="item-loading-mensagem-skeleton skeleton-animation"></div>
  </div>
)

export function ItensEnviadosPage(){
  const [listaItensEnviados, setListaItensEnviados] = useState([]);
  const [filtros, setFiltros] = useState({
    slug_meio_comunicacao: ['email'],
    data_envio_inicio: moment().subtract(7, 'days').toDate(),
    data_envio_fim: moment().toDate()
  })
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(null);
  const [mensagemSelecionada, setMensagemSelecionada] = useState(null);
  const [atendimentoSelecionado, setAtendimentoSelecionado] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const {promiseInProgress:loadingAtendimento} = usePromiseTracker({ area: 'loading-atendimento' });
  const [habilitarExportacaoPdf, setHabilitarExportacaoPdf] = useState(false);
  const [conteudoAtendimentosSelecionados, setConteudoAtendimentosSelecionados] = useState([]);
  const [selecionarTodos, setSelecionarTodos] = useState(false);
  const {promiseInProgress:loadingMensagens} = usePromiseTracker({ area: 'loading-mensagens' });
  const limit = 10;

  useEffect(() => {
    caAPI.configuracoes.buscar("tipo_usuario_permitir_exportar_pdf_atendimento")
      .then((response) => {
        if(response?.data?.valor && response?.data?.status === '1') {
          setHabilitarExportacaoPdf(response?.data?.valor.includes(Number(caAPI.getLocalState('tipoUsuario'))));
        }
      })
  }, []);

  useEffect(()=>{
    if(page === 1){
      buscarItensEnviados({}, true);
    }
    buscarItensEnviados();
  },[page, limit])

  useEffect(()=>{
    if(mensagemSelecionada?.id){
      handleBuscaAtendimento();
    }
  },[mensagemSelecionada])

  const buscarDadosFiltrados = (filtro={})=>{
    setPage(1);
    setAtendimentoSelecionado(null);
    setMensagemSelecionada(null);
    setOpenModal(false);
    filtro.data_envio_inicio = moment(filtro.data_envio_inicio).toDate();
    filtro.data_envio_fim = moment(filtro.data_envio_fim).toDate();
    buscarItensEnviados(filtro, true);
    buscarItensEnviados(filtro);
  }

  const buscarItensEnviados = (filtrosLocal={}, somenteTotal=false)=>{
    let filtroTemp = filtros;
    if(Object.keys(filtrosLocal).length){
      filtroTemp = filtrosLocal;
    }
    const filtro = {
      page,
      limit,
      somente_total: somenteTotal,
      ...filtroTemp
    }

    setFiltros(filtroTemp);

    trackPromise(caAPI.atendimento.buscarItensEnviados(filtro).then((response)=>{
      if(somenteTotal){
        setTotal(response.data.total);
      }else{
        let itensLista = [];
        if(page === 1){
          itensLista = response.data;
        }else{
          itensLista = [...listaItensEnviados, ...response.data];
        }
        setListaItensEnviados(itensLista);
      }
    }).catch((error)=>{
      Swal.fire({
        titleText: "Erro",
        text: "Não foi possivel buscar os itens enviados",
        icon: 'error'
      });
    }), 'loading-mensagens');
  }

  const handleBuscaAtendimento = ()=>{
    if(mensagemSelecionada?.id){
        trackPromise(caAPI.atendimento.find(mensagemSelecionada.id_atendimento).then((response)=>{
          setAtendimentoSelecionado(response.data);
        }).catch((error)=>{
          Swal.fire({
            titleText: "Erro",
            text: "Não foi possivel buscar os itens enviados",
            icon: 'error'
          });
        }), 'loading-atendimento');
    }
  }

  const hasMore = useMemo(()=>{
    return total > listaItensEnviados.length;
  },[total, listaItensEnviados]);

  const handleChangeDate = (date) => {
    let filtroTemp = filtros;
    filtroTemp.data_envio_inicio = date;
    buscarDadosFiltrados(filtroTemp);
  }

  const handleChangeDateFim = (date) => {
    let filtroTemp = filtros;
    filtroTemp.data_envio_fim= date;
    buscarDadosFiltrados(filtroTemp);
  }

  const handleLoadMoreMessages = () => {
    setPage(prevPage => prevPage + 1);
  }

  const handleSelecionarAtendimento = (id) => {
    if(conteudoAtendimentosSelecionados.includes(id)){
      setConteudoAtendimentosSelecionados(conteudoAtendimentosSelecionados.filter(item => item !== id));
    }else{
      setConteudoAtendimentosSelecionados([...conteudoAtendimentosSelecionados, id]);
    }
  }

  const cards = useMemo(()=>{
    return listaItensEnviados?.map((item, index)=>{
      return(
        <CardEnviado item={item} key={index} mensagemSelecionada={mensagemSelecionada} setMensagemSelecionada={setMensagemSelecionada} conteudoAtendimentoSelecionado={conteudoAtendimentosSelecionados.includes(item.id) || selecionarTodos} handleSelecionarAtendimento={handleSelecionarAtendimento}/>
      )
    })
  },[listaItensEnviados, mensagemSelecionada, conteudoAtendimentosSelecionados, selecionarTodos])

  const atendimentoComponent = useMemo(()=>{
    if(atendimentoSelecionado?.id){
      switch(atendimentoSelecionado?.meio?.slug){
        case 'email':
          return(
            <EmailComponent atendimento={atendimentoSelecionado} AtualizarListaEmails={()=>{}} desabilitarFooterEmail={true} mensagemSelecionada={mensagemSelecionada}/>
          )
      }
    }else{
      return <></>
    }
    return <></>
  }, [atendimentoSelecionado])

  const handleExportarAtendimentosPdf = () =>{
    if(conteudoAtendimentosSelecionados.length === 0 && !selecionarTodos){
      Swal.fire('Nenhum atendimento selecionado', '', 'warning');
      return;
    }
    if((selecionarTodos && total > 1000) || conteudoAtendimentosSelecionados.length > 1000){
      Swal.fire('É possível exportar somente 1000 atendimentos por solicitação', '', 'warning');
      return;
    }
    Swal.fire({
      titleText: "Deseja exportar os dados dos atendimento?",
      text: "Confime a realização da ação.",
      icon: "question",
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Sim, exportar!",
      cancelButtonText: "Não, cancelar.",
      customClass: {
        confirmButton: "btn btn-primary mr-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const idsAtendimentosSelecionados = [...new Set(listaItensEnviados.filter(item => selecionarTodos || conteudoAtendimentosSelecionados.includes(item.id)).map(item => item.id_atendimento))];
        trackPromise(caAPI.atendimento.exportarAtendimentosPdf(idsAtendimentosSelecionados, selecionarTodos, filtros))
            .then((response)=>{
              fileDownload(response.data, `Itens_Envidados_${moment().format('YYYYMMDDHHmmss')}.pdf`);
              successToast.fire("Exportação realizada com sucesso!");
            })
            .catch((error)=>{
              errorToast.fire("Erro ao exportar itens enviados!");
            })
      }
    })
  }

  return(
    <>
      <Container fluid className="itens-enviados-page">
        <ReactTooltip/>
        <DommusBarraTitulo>
          <ItemBarraTitulo>
            Itens Enviados
          </ItemBarraTitulo>
          <ItemBarraTitulo classe="periodo">
            <Badge className="badge-identifica-data-tela-inicial" variant="info">Data do envio</Badge>
            <DatePicker
              onChange={handleChangeDate}
              value={filtros.data_envio_inicio}
              format="dd/MM/yyyy"
              calendarIcon={<Icon icon={calendarOutlineBadged} width="20" style={{ color: '#f58442' }}/>}
              clearIcon={null}
            /> <DatePicker
              onChange={handleChangeDateFim}
              value={filtros.data_envio_fim}
              format="dd/MM/yyyy"
              calendarIcon={<Icon icon={calendarOutlineBadged} width="20" style={{ color: '#f58442' }}/>}
              clearIcon={null}
            />
          </ItemBarraTitulo>
          <ItemBarraTitulo classe="btn" onClick={() => {setOpenModal(true)}}>
            <OverlayTrigger
              key="buttonPesquisa"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-Pesquisa`}>
                  Pesquisar
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faSearch} color="#265d9c" />
            </OverlayTrigger>
          </ItemBarraTitulo>
          {habilitarExportacaoPdf && 
            <ItemBarraTitulo classe="btn btn-dropdown">
                <DropdownButton
                  className="btn-dropdown-item-barra"
                  drop={"down"}
                  variant="success"
                  title={<FontAwesomeIcon icon={faEllipsisVertical} color="#f44336" />}
                >
                  <Dropdown.Item
                    eventKey="4"
                    onClick={() =>{
                      handleExportarAtendimentosPdf()
                    }}
                  >
                     Exportar Atendimentos PDF 
                  </Dropdown.Item>
                </DropdownButton>
            </ItemBarraTitulo>
          }
        </DommusBarraTitulo>
        <Container fluid className="itens-enviados-section">
          <Row className="linha-cards-itens">
            <Col md={4} sm={12} className="coluna-item">
              <div className="header-cards-itens">
                <Form.Group>
                  <Form.Check 
                    type="checkbox" 
                    label="Selecionar todos"
                    checked={selecionarTodos}
                    onChange={(event)=>{
                      setSelecionarTodos(event.target.checked);
                      setConteudoAtendimentosSelecionados([]);
                    }}
                  />
                </Form.Group>
                <div>
                  <span>Total: <b>{total}</b></span>
                </div>
              </div>
              <div className="coluna-cards-itens" id="scrollableDivEnviados">
                {loadingMensagens && page == 1 ? componenteLoadingMensagens :
                  cards?.length === 0 ?(
                    <Alert variant="info" className="alert-sem-mensagens">Nenhuma mensagem encontrada para os filtros selecionado.</Alert>
                  ):(
                    <InfiniteScroll
                        className="itens-enviados-container"
                        style={{ display: 'flex' }}
                        dataLength={cards?.length || "0"}
                        next={handleLoadMoreMessages}
                        hasMore={hasMore}
                        inverse={false}
                        loader={<span><Spinner animation="border" style={{ color: '#265d9c' }} /> Carregando</span>}
                        endMessage={
                            <p style={{ textAlign: 'center' }}>
                                <b>Fim das Mensagens</b>
                            </p>
                        }
                        refreshFunction={() => { }}
                        pullDownToRefresh
                        pullDownToRefreshThreshold={50}
                        scrollableTarget="scrollableDivEnviados"
                    >
                        {cards}
                    </InfiniteScroll>
                  )
                }
              </div>
            </Col>
            <Col md={8} sm={12} className="coluna-item coluna-visualizacao-atendimento">
              {loadingAtendimento ? 
                componenteLoadingAtendimento :
                (
                  mensagemSelecionada?.id && atendimentoSelecionado?.id ?
                  atendimentoComponent : 
                  <DommusPlaceholderDetalhesAtendimento/>
                )
              }
            </Col>
          </Row>
        </Container>
      </Container>
      <ModalDommus
        open={openModal}
        close={() => setOpenModal(false)}
        titulo="Filtro"
      >
       <FiltroItensEnviados filtros={filtros} handleAplicarFiltro={buscarDadosFiltrados} closeModal={()=>{setOpenModal(false)}}/>
      </ModalDommus>
    </>
  )
}
